import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_URL } from '../styles/shared';

export function useMarketData(isLoggedIn = false) {
  const [marketData,   setMarketData]   = useState(null);
  const [topGainers,   setTopGainers]   = useState([]);
  const [topLosers,    setTopLosers]    = useState([]);
  const [mostActive,   setMostActive]   = useState([]);
  const [moversSource, setMoversSource] = useState('');

  const fetchMarketData = useCallback(async () => {
    try {
      const [overviewRes, moversRes] = await Promise.all([
        axios.get(`${API_URL}/api/market/overview`),
        axios.get(`${API_URL}/api/market/movers`),
      ]);
      if (overviewRes.data.success) setMarketData(overviewRes.data.data);
      if (moversRes.data.success) {
        const d = moversRes.data.data;
        setTopGainers(d.topGainers || []); setTopLosers(d.topLosers || []);
        setMostActive(d.mostActive || []); setMoversSource(d.dataSource || '');
      }
    } catch (err) { console.log('Market data error:', err.message); }
  }, []);

  useEffect(() => {
    fetchMarketData();
    const interval = setInterval(fetchMarketData, isLoggedIn ? 2 * 60 * 1000 : 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchMarketData, isLoggedIn]);

  const refresh = () => {
    setTopGainers([]); setTopLosers([]); setMostActive([]);
    fetchMarketData();
  };

  return { marketData, topGainers, topLosers, mostActive, moversSource, refresh };
}
